export default __webpack_public_path__ + "static/media/img3.dc7ddb5e.webp";